import { getLocale, getTimeZone } from '@vue3/utils/common.js'
import constants from '@vue3/constants'

const TIMEZONE = getTimeZone()
const LOCALE = getLocale()

export const dateFormatter = (value, options = constants.dateFormat.DD_MON_YYYY, showTimeZone = false) => {
  let date = new Date(value).toLocaleDateString(LOCALE, options)
  if (showTimeZone) {
    date = `${date} ${TIMEZONE}`
  }
  return date
}

export const currencyFormatter = (value, config = { showZero: true, showSymbol: true }) => {
  const symbol = config.showSymbol ? 'Rp' : ''
  const thousandsSeparator = '.'
  const fractionCount = 0
  let result = 0.0
  let beforeDot

  const amount = parseFloat(value)
  if (!isNaN(amount)) {
    result = amount
  }

  result = result.toFixed(fractionCount)
  const _ref = result.split('.')
  beforeDot = _ref[0]
  const pattern = /(-?\d+)(\d{3})/
  while (pattern.test(beforeDot)) {
    beforeDot = beforeDot.replace(pattern, '$1' + thousandsSeparator + '$2')
  }
  result = beforeDot

  result = result === '0' && !config.showZero ? '-' : result
  if (!config.showZero && result === '-') {
    return result
  }
  const string = [result]
  string.splice(0, 0, symbol)
  result = string.join('')

  return result
}

export const thousandSeparator = (value) => {
  if (typeof value === 'number') {
    return value.toLocaleString('id')
  } else {
    return value
  }
}

export const priceToNumberFormatter = (value) => {
  return Number(value.replace(/\D/g, ''))
}

